import { config, handleResponse } from '../../_helpers';

export const customerServices = {
    getAllCustomers,
    getActiveCustomers,
    getCustomers,
    loadCustomers,
    createCustomer,
    updateCustomer,
    getCustomerById,
    deleteCustomers,
    activation,
    sQSearchCust,
    sQSearchCustApprovedViewer,
    searchSQShipperConsignee,
    custCodeSearch,
    getCMDPayor,
    searchSQShipperConsigneeWithGroup,
    CustIsRatesCommodity,
    CustsqPerBag,
    getCustomerIdFromBase,
    isStrippingStuffing,
    GetCollectionPayor,
    getCustomerDetails,
    loadCustomersNew,
    shipperRatesCommodity,
    ratesCommodityNotNullCategory,
    computeInsurance,

    searchAeId,
};

function searchAeId() {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(""),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Customers/searchAeId`, requestOptions).then(handleResponse);
}

function getAllCustomers() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Customers`, requestOptions).then(handleResponse);
}
function getActiveCustomers() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Customers/getIsActive`, requestOptions).then(handleResponse);
}
// Transaction
function getCustomers(skip, take, filter, search, customerCode) {
    let payload = {
        skip: skip,
        take: take,
        filter: filter,
        search: search,
        isActive: true,
        code: customerCode ? customerCode : '',
    }
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Customers/load`, requestOptions).then(handleResponse);
    // const requestOptions = {
    //     method: 'GET'
    // };
    // if (search) {
    //     return fetch(`${config.apiUrl}/Customers/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}&isActive=true`, requestOptions).then(handleResponse);
    // } else {
    //     return fetch(`${config.apiUrl}/Customers/load?skip=${skip}&take=${take}&filter=${filter}&isActive=true`, requestOptions).then(handleResponse);
    // }
}
// Master Data
function loadCustomers(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        return fetch(`${config.apiUrl}/Customers/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/Customers/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
// NEW
function loadCustomersNew(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Customers/loadCustomer`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Customers/loadCustomerV1`, requestOptions).then(handleResponse);
}
function createCustomer(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Customers`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Customers/createWithDetails`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Customers/createWithDetailsV1`, requestOptions).then(handleResponse);
}
function updateCustomer(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Customers/update/${id}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Customers/updateWithDetails/${id}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Customers/updateWithDetailsV1/${id}`, requestOptions).then(handleResponse);
}
function getCustomerById(code) {
    const requestOptions = {
        method: 'GET'
    };

    // return fetch(`${config.apiUrl}/Customers/get/${code}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Customers/getWithDetails/${code}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Customers/getWithDetailsV1/${code}`, requestOptions).then(handleResponse);
}
function deleteCustomers(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    // return fetch(`${config.apiUrl}/Customers/delete`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Customers/deleteV1`, requestOptions).then(handleResponse);
}
function activation(id, isActive, user) {
    const requestOptions = {
        method: 'PUT'
    };

    return fetch(`${config.apiUrl}/Customers/activate/${id}?isActive=${isActive}&userId=${user}`, requestOptions).then(handleResponse);
}
function sQSearchCust(search) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Customers/sQSearchCust?search=${search}`, requestOptions).then(handleResponse);
}
function sQSearchCustApprovedViewer(search) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Customers/sQSearchCustApprovedViewer?search=${search}`, requestOptions).then(handleResponse);
}

function searchSQShipperConsignee(shipper, consignee) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Customers/searchSQShipperConsignee?shipper=${shipper}&consignee=${consignee}`, requestOptions).then(handleResponse);
}

function custCodeSearch(search) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Customers/custCodeSearch?search=${search}`, requestOptions).then(handleResponse);
}

function getCMDPayor(payload, search) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    if(search){
        return fetch(`${config.apiUrl}/Customers/getCMDPayor?search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/Customers/getCMDPayor`, requestOptions).then(handleResponse);
    }
}
function searchSQShipperConsigneeWithGroup(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Customers/searchSQShipperConsigneeWithGroup`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Customers/searchSQShipperConsigneeRates`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Customers/searchSQShipperConsigneeRatesRequested`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Customers/searchSQShipperConsigneeRatesSQValidity`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Customers/customerCharges`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Customers/customerChargesV1`, requestOptions).then(handleResponse);
}

function CustIsRatesCommodity(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Customers/CustIsRatesCommodity`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Customers/CustRatesBasisCommodity`, requestOptions).then(handleResponse);
}

function CustsqPerBag(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Customers/CustsqPerBag`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Customers/CustRatesPerBag`, requestOptions).then(handleResponse);
}

function getCustomerIdFromBase(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
        return fetch(`${config.apiUrl}/Customers/getCustomerIdFromBase`, requestOptions).then(handleResponse);
}

function isStrippingStuffing(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
        return fetch(`${config.apiUrl}/Customers/isStrippingStuffing`, requestOptions).then(handleResponse);
}
function GetCollectionPayor(shipper, consignee) {
    const requestOptions = {
        method: 'POST',
    };
    return fetch(`${config.apiUrl}/Customers/GetCollectionPayor?shipper=${shipper}&consignee=${consignee}`, requestOptions).then(handleResponse);
}
function getCustomerDetails(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Customers/getCustomerDetails`, requestOptions).then(handleResponse);
}

function shipperRatesCommodity(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Customers/shipperRatesCommodity`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Customers/shipperRatesCommodity1`, requestOptions).then(handleResponse);
}

function ratesCommodityNotNullCategory(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Customers/ratesCommodityNotNullCategory`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Customers/ratesCommodityNotNullCategoryV1`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Customers/commodityNotNullCharge`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/Customers/commodityNotNullCharge1`, requestOptions).then(handleResponse);
}

function computeInsurance(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Customers/computeInsurance`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Customers/computeInsuranceWithOtherCharges`, requestOptions).then(handleResponse);
}